<div class="gacha-content">
  <div>
    <h2 class="confirm title header-text heavy-header-text" mat-dialog-title>
      Mystery Pocket Pet Dispenser
    </h2>
    <mat-dialog-content>
      <p>
        Would you like to buy a mystery critter for {{ AVATAR_COST }} sand
        dollars?
      </p>
      <div class="row justify-start align-items-centered">
        <img
          class="coin"
          src="/assets/img/coin/coin_purse.png"
          alt="Image of coin in the shape of a sand dollar"
        />
        <h2 class="confirm title header-text heavy-header-text">
          &Phi; {{ AVATAR_COST }}
        </h2>
      </div>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions class="centered">
    <h2 *ngIf="submitDisabled" class="confirm">
      You do not have enough sand dollars!
    </h2>
    <app-confirm-cancel
      [buttonConfig]="buttonConfig"
      [disableSubmit]="submitDisabled"
      (emitSubmit)="submit()"
    >
    </app-confirm-cancel>
  </mat-dialog-actions>
</div>
